import React from 'react';
import { connect } from 'react-redux';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { getTranslatedString } from 'helpers/i18n';
import * as formatter from 'helpers/Formatter';

const styles = {
  new_badge: {
    opacity: '0.6',
    padding: '0',
    minWidth: '15px',
    textAlign: 'center',
    fontSize: '10px',
    lineHeight: '15px',
    minHeight: '14px',
    borderRadius: '3px',
    color: '#fff',
    display: 'inline-block',
    verticalAlign: 'text-bottom',
    marginRight: '10px !important',
  },
  filter_buttons: {
    padding: '5px 10px',
    marginRight: '5px',
    display: 'inline-block',
    borderRadius: '3px',
    cursor: 'pointer',
  },
  filter_buttons_no_margin: {
    padding: '5px 10px',
    display: 'inline-block',
    borderRadius: '3px',
    cursor: 'pointer',
  },
  choose_property: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#ffffff',
    padding: '15px 0px',
    zIndex: '4',
  },
};

class EventCalendarBasic extends React.Component {
  state = {
    showAmenities: true,
    showEvents: true,
    showInspections: true,
    showCalendarHolds: true,
  };

  getRandomColor = () => {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  eventStyleGetter = (event) => {
    const eventColors = {
      amenity_booking: this.getRandomColor(),
      site_event: '#34a1ff',
    };

    let backgroundColor = eventColors[event.event_subtype];
    const style = {
      backgroundColor: backgroundColor,
      color: 'white',
    };
    return {
      style: style,
    };
  };

  showAmenity = (shouldShow) => {
    return shouldShow ? 'filter-selected' : '';
  };

  render() {
    moment.locale(this.props.languageCode);
    BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

    let events = this.props.siteEvents.map((event) => {
      let title = event.target_name;
      if (event.target_type) {
        let typeTranslation = getTranslatedString(
          `landlordPortal.calendarPage.${event.target_type}`
        );
        if (event.is_calendar_hold) {
          title = `${event.target_name} ${getTranslatedString('landlordPortal.calendarPage.hold')}`;
        } else {
          title = `${event.target_name} ${typeTranslation}`;
        }
      }

      if (!!event.unit) {
        title = `${getTranslatedString('unit')} ${event.unit} ${title}`;
      }

      return {
        id: event.id,
        title: title,
        start: formatter.toDate(event.start),
        end: formatter.toDate(event.end),
        event_type: event.event_type,
        event_subtype: event.event_subtype,
        is_calendar_hold: event.is_calendar_hold,
      };
    });

    events = events.filter((event) => {
      if (event.event_subtype === 'site_event' && this.state.showEvents) {
        return true;
      } else if (event.event_subtype === 'inspection_booking' && this.state.showInspections) {
        return true;
      } else if (
        event.event_subtype === 'amenity_booking' &&
        !event.is_calendar_hold &&
        this.state.showAmenities
      ) {
        return true;
      } else if (event.is_calendar_hold && this.state.showCalendarHolds) {
        return true;
      }

      return false;
    });

    return (
      <div className="dashboard-container" style={{ height: '100%' }}>
        <div className="row">
          <div className="col-sm-7" style={{ paddingLeft: 0, marginBottom: '15px' }}>
            <div
              style={styles.filter_buttons}
              id={this.showAmenity(this.state.showAmenities)}
              onClick={() => this.setState({ showAmenities: !this.state.showAmenities })}
            >
              <p style={{ marginBottom: '2px', display: 'inline-block' }}>
                <span className="statusTag amenity-calendar" style={styles.new_badge} />{' '}
                {getTranslatedString('landlordPortal.calendarPage.amenities')}{' '}
              </p>
            </div>
            <div
              style={styles.filter_buttons}
              id={this.showAmenity(this.state.showEvents)}
              onClick={() => this.setState({ showEvents: !this.state.showEvents })}
            >
              <p style={{ marginBottom: '2px', display: 'inline-block' }}>
                <span className="statusTag event-calendar" style={styles.new_badge} />{' '}
                {getTranslatedString('landlordPortal.calendarPage.events')}{' '}
              </p>
            </div>
          </div>
          <div className="col-sm-5" style={{ paddingRight: 0, marginBottom: '15px' }}>
            <MultiSelectExtended
              onChange={this.props.onPropertySelect}
              name="property_select"
              hintText={getTranslatedString('landlordPortal.calendarPage.selectAProperty')}
              data={this.props.properties}
              menuStyle={{ fontSize: '14px' }}
              textFieldStyle={{ padding: 0 }}
              style={{ fontSize: '14px' }}
              minHeight={'32px'}
              fireOnChangeIfBlank
              multiple
              withResetSelectAllButtons
            />
          </div>
        </div>

        <div style={{ height: '100%' }}>
          <BigCalendar
            selectable
            events={events}
            defaultDate={new Date()}
            onSelectEvent={this.props.onSelectEvent}
            onSelectSlot={(slotInfo) => this.props.onSelectSlot(slotInfo)}
            views={['month', 'week', 'day', 'agenda']}
            messages={{
              day: getTranslatedString('reactBigCalendar.day'),
              week: getTranslatedString('reactBigCalendar.week'),
              month: getTranslatedString('reactBigCalendar.month'),
              agenda: getTranslatedString('reactBigCalendar.agenda'),
              today: getTranslatedString('reactBigCalendar.today'),
              previous: getTranslatedString('reactBigCalendar.previous'),
              next: getTranslatedString('reactBigCalendar.next'),
            }}
            eventPropGetter={this.eventStyleGetter}
            onRangeChange={this.props.handleRangeChange}
          />
          {this.props.siteEvents.length === 0 && (
            <h5 style={styles.choose_property}>
              {' '}
              {getTranslatedString('landlordPortal.calendarPage.noEventsToView')}{' '}
            </h5>
          )}
        </div>
      </div>
    );
  }
}

export default connect((store) => ({
  languageCode: store.locale.currentLanguage,
}))(EventCalendarBasic);
